import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { user, profile, loading, profileReady } = useAuth();

  const canAccessAdmin = profile?.role === 'superadmin' || profile?.role === 'editor';

  if (loading || !profileReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Laster...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessAdmin) {
    return <Navigate to="/assessment/start" replace />;
  }
  return <>{children}</>;
}
